import { render } from "./SliderComponent.vue?vue&type=template&id=beee6560&scoped=true"
const script = {}

import "./SliderComponent.vue?vue&type=style&index=0&id=beee6560&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-beee6560"

export default script